<template>
  <nav>
    <!-- App Bar -->
    <v-app-bar
      app
      color="rgba(255, 255, 255, 1)"
      elevate-on-scroll
      class="nav-glass elevation-4"
      dense
      height="80"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="nav-glow" />
      <v-img
        src="@/assets/prg-logo.png"
        class="logo pointer"
        max-width="50"
        height="50"
        @click="nav('home')"
        contain
      ></v-img>
      <!-- <span class="logo-title ml-2 d-none d-sm-inline-block">Instaguard Security</span> -->
      <v-spacer />
      <!-- <span class="logo-title ml-2 d-none d-md-flex">Instaguard</span>
      <v-spacer /> -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="user-info" v-bind="attrs" v-on="on">
            <v-avatar size="35" class="user-avatar">
              <img :src="userInfo.profilePic" />
            </v-avatar>
            <span class="user-name d-none d-sm-inline-block ml-2">{{ userInfo.name }}</span>
            <v-icon class="ml-1" small>mdi-menu-down</v-icon>
          </div>
        </template>
        <v-list dark class="menu-glass">
          <v-list-item @click="nav('Users')">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
      dark
      color="rgba(22, 28, 38, 0.88)"
      class="drawer-glass"
      :width="$vuetify.breakpoint.smAndDown ? 240 : 330"
      :temporary="$vuetify.breakpoint.smAndDown"
      floating
    >
      <v-layout column align-center class="pt-6 pb-2 px-2">
        <br />

          <img width="100" height="65" src="@/assets/prg-logo.png" alt="Logo" />
        
                <br />
                   
        <div class="drawer-user-info mb-5">
          <div class="user-badge-glow"></div>
          <v-avatar size="32" class="drawer-user-avatar mr-1">
            <img :src="userInfo.profilePic" />
          </v-avatar>
          <span class="drawer-user-name">{{ userInfo.name }}</span>
        </div>
        <v-divider class="mb-3" style="width:100%;"></v-divider>
                <br />
        <br />
        <transition-group name="list" tag="div" class="w-100">
          <v-btn
            v-for="item in navItems"
            :key="item.text"
            :href="item.href"
            class="dashboard-nav-btn mb-2"
          large
          block
          color="white"
          outlined
          dark
          >
            <v-avatar size="32" class="mr-3">
              <img :src="item.icon" />
            </v-avatar>
            <span class="nav-label">{{ item.text }}</span>
          </v-btn>
        </transition-group>
        <br />
        <br />

        <br />
        <v-divider class="my-4" style="width:85%;"></v-divider>
        <ThemeChanger />
      </v-layout>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import ThemeChanger from '@/components/ThemeChanger.vue';

export default {
  name: "Nav",
  data: () => ({
    drawer: false,
    userInfo: {},
    navItems: [
      {
        text: "Dashboard",
        href: "/userdashboard",
        icon: require('@/assets/DashboardIcon.png'),
      },
      // {
      //   text: "Interface",
      //   href: "/Interface",
      //   icon: require('@/assets/InterfaceIcon2.png'),
      // },
            {
        text: "Artist Analyst",
        href: "/aiartistanalystv2",
        icon: require('@/assets/AIANALYST450px.png'),
      },
                  {
        text: "Tour Analyst",
        href: "/touranalyst",
        icon: require('@/assets/CodexData.png'),
      },
      {
        text: "Tour Prediction",
        href: "/tourprediction",
        icon: require('@/assets/DashIcon.png'),
      },
      {
        text: "Tour Router",
        href: "/tourrouter",
        icon: require('@/assets/Concierge.png'),
      },
              {
        text: "Gallery",
        href: "/artistgallery",
        icon: require('@/assets/AccountIconv3.png'),
      },
    ],
  }),
  components: {
    ThemeChanger,
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("currentUser")) || {};
  },
  methods: {
    nav(path) {
      this.$router.push({ name: path });
    },
    logout() {
      localStorage.clear();
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped>
.menu-glass {
  background: rgba(18, 28, 38, 0.7) !important;
  backdrop-filter: blur(10px) saturate(150%);
  box-shadow: 0 2px 16px #00f1ff33, 0 1.5px 0 #13efe533;
  margin-top: 8px; left: 0; right: 0;
  border-radius: 0 0 24px 24px;
  z-index: 1;
}
/* ==== App Bar Styles ==== */
.nav-glass {
  background: rgba(27,38,58,0.2) !important;
  backdrop-filter: blur(7px) saturate(170%);
  border-bottom: 1.5px solid #29fff5cc;
  box-shadow: 0 2px 8px 0 #18e0c746;
  border-radius: 0 0 24px 24px;
}
.logo {
  padding: 4px;
  transition: box-shadow 0.18s, transform 0.18s;
}
/* .logo {
  border-radius: 18px;
  box-shadow: 0 1px 12px #00fff66e;
  background: rgba(18,32,48,0.8);
  padding: 4px;
  transition: box-shadow 0.18s, transform 0.18s;
} */
.logo:hover {
  /* box-shadow: 0 2px 28px #29fff5cc; */
  transform: scale(1.11);
}
.logo-title {
  font-family: 'Orbitron', 'Montserrat', Arial, sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 2px;
  color: #0ef1e6;
  text-shadow: 0 2px 12px #13efe570;
}
.user-info {
  display: flex; align-items: center; cursor: pointer;
  background: rgba(18,28,38,0.72);
  padding: 4px 12px; border-radius: 18px;
  box-shadow: 0 1px 8px #18e0c746;
  transition: background 0.18s;
}
.user-info:hover { background: rgba(30,40,50,0.82);}
.user-avatar {
  border: 2px solid #13efe5cc; box-shadow: 0 2px 10px #13efe5a1;
}
.user-name { font-weight: 600; color: #fff; text-shadow: 0 1px 4px #29fff4bb;}

/* ==== Drawer Styles ==== */
.drawer-glass {
  background: rgba(22,28,38,0.90) !important;
  backdrop-filter: blur(15px) saturate(170%) brightness(1.1);
  box-shadow: 0 4px 48px #00f1ff21, 0 1.5px 0 #13efe556;
  /* border-radius: 0 20px 20px 0; */
  border-right: 2px solid #1bfff0a8;
  margin-top: -90px; /* Below app bar */
}
.drawer-logo {
  background: rgba(0,0,0,0);
  width: 100%;
  height: 100%;
  /* border-radius: 20px;
  box-shadow: 0 2px 20px #13efe57a; */
}
.drawer-user-info {
  position: relative;
  display: flex;
  align-items: center;
  padding: 9px 20px;
  margin-top: -10px;
  margin-bottom: 10px;
  background: rgba(31, 45, 70, 0.67);
  border-radius: 22px;
  box-shadow: 0 2px 14px #13efe533;
}
.user-badge-glow {
  position: absolute; left: -8px; top: 50%; transform: translateY(-50%);
  width: 13px; height: 13px; background: #16ffe6;
  border-radius: 50%; box-shadow: 0 0 12px #12fff6aa, 0 0 32px #13efe5a2;
  opacity: 0.89;
}
.drawer-user-avatar { border: 2px solid #0ef1e6; }
.drawer-user-name {
  font-size: 1.05rem; font-weight: 600;
  color: #14ece9; letter-spacing: 1.2px;
  text-shadow: 0 2px 10px #13efe555;
  margin-left: 2px;
}
.dashboard-nav-btn {
  background: linear-gradient(100deg, #1f2340 30%, #1f2340 70%, #1f2340 100%) !important;
  border-radius: 8px !important;
  color: #fff !important;
  padding: 30px 30px 30px 30px !important;
  margin: 0px 20px 6px 20px !important;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  text-transform: none !important;
  font-weight: 600;
  font-size: 1.1rem;
  box-shadow: 0 2px 18px #1afffa31;
  border: 2px solid #10e4ff33;
  letter-spacing: 0.65px;
  left: -20px;
  position: relative;
  z-index: 1;
  text-decoration: none !important;
  overflow: hidden;
  min-width: 0;
  transition:
    border-color 0.24s,
    box-shadow 0.22s,
    background 0.26s,
    color 0.18s,
    transform 3s;
  cursor: pointer;
  outline: none;
}
.dashboard-nav-btn:active {
  transform: scale(0.98);
}
.dashboard-nav-btn:focus-visible {
  border-color: #0fffd7 !important;
  box-shadow: 0 0 18px #00ffe988, 0 0 2px #12fff888;
}
.dashboard-nav-btn:hover {
  background: linear-gradient(100deg, #13cbe7 0%, #19ffc6 85%, #19ffc6 100%) !important;
    border-radius: 18px !important;
  border-color: #1ffff1 !important;
  color: #003333 !important;
  box-shadow: 0 0 36px #13efe57c, 0 2px 36px #1dfbfa63;
  filter: brightness(1.04);
}

/* Icon Avatar stays up */
.dashboard-nav-btn .v-avatar {
  margin-bottom: 2px;
  margin-right: 16px;
  box-shadow: 0 1px 10px #1afffa34;
  transition: transform 0.17s;
}
.dashboard-nav-btn:hover .v-avatar {
  transform: scale(1.12) rotate(-7deg);
}

.nav-label {
  flex: 1 1 auto;
  text-align: left;
  font-size: 1.05rem;
  font-weight: 500;
  letter-spacing: 1px;
  color: inherit;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.nav-meta {
  font-size: 0.93em;
  color: #23ffe8;
  opacity: 0.8;
  margin-top: 3px;
  font-weight: 400;
  text-shadow: 0 1px 8px #15ffc433;
  letter-spacing: 0.5px;
  transition: color 0.18s;
}

.dashboard-nav-btn:hover .nav-meta {
  color: #0effbb;
  opacity: 1;
}

.nav-btn-bottom-row {
  display: flex;
  align-items: center;
  margin-top: 3px;
  gap: 12px;
}

/* ==== Counter Badge ==== */
.nav-btn-counter {
  margin-left: 8px;
  min-width: 32px;
  padding: 2px 12px;
  background: linear-gradient(90deg, #00ffe9 40%, #14fa9a 100%);
  color: #013b42;
  border-radius: 14px;
  font-size: 1.02em;
  font-weight: 700;
  box-shadow: 0 0 10px #18e0c7aa;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #12fff666;
  position: relative;
  animation: counterPop 1.2s cubic-bezier(.56,-0.3,.42,1.6) 1;
  transition: background 0.2s, color 0.2s;
}
@keyframes counterPop {
  0%   { transform: scale(0.4); opacity: 0.5;}
  40%  { transform: scale(1.1); }
  70%  { transform: scale(0.97);}
  100% { transform: scale(1); opacity: 1;}
}
.dashboard-nav-btn:hover .nav-btn-counter {
  background: linear-gradient(90deg, #19ffc6 35%, #07f7ff 100%);
  color: #00413c;
  border-color: #13ffe1;
}

/* Pulse effect when count is not zero */
.nav-btn-counter[data-count]:not([data-count="0"])::after {
  content: "";
  position: absolute;
  top: -6px; left: -7px; right: -7px; bottom: -6px;
  border-radius: 14px;
  background: radial-gradient(ellipse at center, #09ffe888 45%, transparent 75%);
  z-index: 0;
  pointer-events: none;
  animation: badgePulse 2s infinite;
}
@keyframes badgePulse {
  0% { opacity: 0.38; }
  50% { opacity: 0.82; }
  100% { opacity: 0.38; }
}

.dashboard-nav-btn:active {
  filter: brightness(0.97) saturate(1.4);
  transform: scale(0.98);
  box-shadow: 0 0 22px #16ffd799;
}

/* ==== Responsive ==== */
@media (max-width: 960px) {
  .dashboard-nav-btn { font-size: 1.06rem; padding: 11px 10px 9px 8px !important; }
  .nav-btn-counter { font-size: 1em; min-width: 26px; padding: 2px 7px;}
  .nav-label { font-size: 1.02rem; }
  .nav-meta { font-size: 0.89em; }
}
@media (max-width: 600px) {
  .dashboard-nav-btn { font-size: 0.97rem; padding: 9px 4px 8px 6px !important; }
  .nav-label { font-size: 0.97rem; }
  .nav-btn-counter { margin-left: 5px; font-size: 0.93em; }
}


</style>
